import createIcon from '../../createIcon';

/**
 * @component @name BatterySaver
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYgNEgxNFYySDEwVjRIOEM3LjQ1IDQgNyA0LjQ1IDcgNVYyMUM3IDIxLjU1IDcuNDUgMjIgOCAyMkgxNkMxNi41NSAyMiAxNyAyMS41NSAxNyAyMVY1QzE3IDQuNDUgMTYuNTUgNCAxNiA0Wk0xNSAxNEgxM1YxNkgxMVYxNEg5VjEySDExVjEwSDEzVjEySDE1VjE0WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BatterySaver = createIcon('BatterySaver', [
  [
    'path',
    {
      d: 'M16 4H14V2H10V4H8C7.45 4 7 4.45 7 5V21C7 21.55 7.45 22 8 22H16C16.55 22 17 21.55 17 21V5C17 4.45 16.55 4 16 4ZM15 14H13V16H11V14H9V12H11V10H13V12H15V14Z',
      key: '1a3rvv',
    },
  ],
]);

export default BatterySaver;
